export { DeliveryTermsContent as default } from 'features/store/pages/delivery-store-selector/delivery-terms-modal';
